export const FEATURE_FLAGS = {
  BANNER_DATA: 'app.ui_banner',
  OLH_VERSION: 'app.olh_version',
  NC_CONFIG: 'app.notifications_center.config', // { isVisible,showAnnouncements,showActivities }
  LANGUAGE_SWITCHER_VISIBILITY: 'app.language_switcher_visibility.enable',
  REGION_VISIBILITY: 'app.region_visibility.enable',
  ALERT_NOTIFICATION_DETAILS: 'app.alert_notification_details.enable',
  EARLY_ACCESS_VISIBILITY: 'app.early_access_visibility.enable',
  CLOUDFLARE_INTEGRATION_VISIBILITY: 'asm.claudflare_integration_visibility.enable',
  BLAST_VISIBILITY: 'app.blast_visibility.enable',
  CAASM_WIDGET_CDN: 'caasm.widget_cdn',
  CAASM_ALLOWED_REGIONS: 'caasm.allowed_regions.config',
  TEM_ALLOWED_REGIONS: 'tem.allowed_regions.config',
  CYBER_NEWS: 'app.cyber_news.enable',
  ASSET_MGMT: 'app.asset_mgmt.enable',
  ALERTS_FORCE_IN_REVIEW_VISIBILITY: 'alerts.force_in_review_visibility.enable',
  AI_REVERSER_VISIBILITY: 'app.ai_reverser_visibility.enable',
  MULTI_TENANT_TENANT_TYPE: 'app.multi_tenant_tenant_type.enable',
  TI_THREAT_READINESS_DASHBOARD_ENABLED: 'ti.threat_readiness_dashboard.enable',
  MSSP_FILTERED_VIEW_VISIBILITY: 'app.mssp_filtered_view.view',
  CREATE_ALERT_API_VISIBILITY: 'app.create_alert_api_visibility.enable',
  ACCESS_LOGS_INTEGRATIONS_VISIBILITY: 'alerts.access_logs_integrations_visibility.enable',
  TEM_ESSENTIALS_TENANT_VISIBILITY: 'app.tem_essentials_tenant.enable',
  MSSP_STANDALONE_CONVERSION_VISIBILITY: 'app.mssp_standalone_conversion.enable',
  TENANT_MGMT_HINT_VISIBILITY_DATE: 'app.token_mgmt_visibility_hint.date'
};
